<!-- {{ data }} -->
@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid mb-4" id="container-fluid">
    <div class="row">
      <div class="col-5 p-3" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
        <h3 class="font-weight-bold">
          {{ user_detail.first_name }} {{ user_detail.last_name }}
        </h3>
        <h6 class="font-weight-bold text-black-50">
          {{ user_detail.description }}
        </h6>
      </div>
      <!-- <div class="col-2 mt-4   text-white text-center apply2">
      <a href="" class="btn btn-secondary bg-secondary"><i class="icon-plus"></i>  Apply Leave</a>
    </div> -->
    <div class="col mt-2 text-white text-center space working-attend"
      [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <span class="font-weight-bold">Month</span>
      <h3 class="font-weight-bold mt-4">{{ salary_detail.month_char }}</h3>
    </div>
    <div class="col mt-2 text-white text-center space worked-attend"
      [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <span class="font-weight-bold">Total Salary
        <span>
          {{ user_detail.salary_type === 'hourly' ? 'Per Hour' : (user_detail.salary_type === 'monthly' ? 'Per
          Monthly' :
          'Monthly') }}
        </span>
      </span>
      <h3 class="font-weight-bold mt-4">{{ salary_detail.basic_salary }}/-</h3>
    </div>
    @if (user_detail.salary_type !== 'hourly') {
      <div class="col mt-2 text-white text-center space overtime"
        [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
        <span class="font-weight-bold">Deduction</span>
        <h3 class="font-weight-bold mt-4">
          {{
          salary_detail.total_deduction === null
          ? "0"
          : salary_detail.total_deduction
          }}/-
        </h3>
      </div>
    }
    <div class="col mt-2 text-white text-center missing-check space"
      [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <span class="font-weight-bold">This Month Salary</span>
      <h3 class="font-weight-bold text-center mt-4">
        {{
        salary_detail.released_salary === null
        ? "0"
        : salary_detail.released_salary
        }}/-
      </h3>
    </div>
  </div>

  <div class="row">
    <div class="col-xl-12 col-sm-6 col-12" style="margin-top: 50px">
      <div class="card">
        <div class="card-content rounded">
          <div class="card-body rounded-top" style="background-color: #112a5f"
            [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <div class="media text-center text-white font-weight-bold font-italic">
              <div class="col">
                <span class="text">Salary Calculation for the month of
                  {{ salary_detail.month_char }}
                {{ salary_detail.month_year }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-6 col-sm-3 col-6">
      <table class="table table-bordered" [ngClass]="{ 'dark-backround-table': selectedMode === 'dark' }">
        <thead>
          <tr>
            <th>Employee Code:</th>
            <td>{{ user_detail.attendance_user_id }}</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>Employee Name:</th>
            <td>{{ user_detail.first_name }} {{ user_detail.last_name }}</td>
          </tr>
          <tr>
            <th>Designation:</th>
            <td>{{ user_detail.description }}</td>
          </tr>
          <tr>
            <th>Department:</th>
            <td>{{ user_detail.department }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="col-xl-6 col-sm-3 col-6">
      <table class="table table-bordered" [ngClass]="{ 'dark-backround-table': selectedMode === 'dark' }">
        <thead>
          <tr>
            <th>Date of Joining:</th>
            <td>
              {{
              user_detail.joining_date === null
              ? ""
              : user_detail.joining_date
              }}
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>CNIC:</th>
            <td>{{ user_detail.cnic }}</td>
          </tr>
          <tr>
            <th>Employment Type:</th>
            <td>{{ user_detail.employee_type }}</td>
          </tr>
          <tr>
            <th>Employment Status:</th>
            <td>{{ user_detail.employee_status }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="row">
    <div class="col-xl-6 col-sm-6 col-6" style="margin-top: 30px">
      <div class="card">
        <div class="card-content rounded">
          <div class="card-body rounded-top" style="background-color: #112a5f"
            [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <div class="media text-center text-white font-weight-bold font-italic">
              <div class="col">
                <span class="text">Actual Details</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <table class="table table-bordered" [ngClass]="{ 'dark-backround-table': selectedMode === 'dark' }">
          <tbody>
            @if (user_detail.salary_type !== 'hourly') {
              <tr>
                <th style="width: 50%; padding: 0px">
                  <p style="margin: 11px">Absent's</p>
                </th>
                <td>
                  {{
                  salary_detail.absents === null ? "0" : salary_detail.absents
                  }}
                </td>
              </tr>
            }
            @if (user_detail.salary_type !== 'hourly') {
              <tr>
                <th>Un Paid Leaves</th>
                <td>
                  {{
                  salary_detail.unpaid_leaves === null
                  ? "0"
                  : salary_detail.unpaid_leaves
                  }}
                </td>
              </tr>
            }

            @if (user_detail.salary_type !== 'hourly') {
              <tr>
                <th>Paid Leaves</th>
                <td>
                  {{
                  salary_detail.paid_leaves === null
                  ? "0"
                  : salary_detail.paid_leaves
                  }}
                </td>
              </tr>
            }

            @if (user_detail.salary_type !== 'hourly') {
              <tr>
                <th>Late Check In (Hours)</th>
                <td>
                  {{
                  salary_detail.late_check_in === null
                  ? "0"
                  : salary_detail.late_check_in
                  }}
                </td>
              </tr>
            }
            @if (user_detail.salary_type !== 'hourly') {
              <tr>
                <th>Short Hours</th>
                <td>
                  {{
                  salary_detail.short_hours === null
                  ? "0"
                  : salary_detail.short_hours
                  }}
                </td>
              </tr>
            }
            @if (user_detail.salary_type !== 'hourly') {
              <tr>
                <th>Over Time (Hours)</th>
                <td>
                  {{
                  salary_detail.overtime_hours === null ? "0" : salary_detail.overtime_hours
                  }}
                </td>
              </tr>
            }


            @if (user_detail.salary_type === 'hourly') {
              <tr class="total-hours">
                <th>Total Hour Work</th>
                <td>
                  {{ salary_detail.total_worked_hours ?? "0" }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-xl-6 col-sm-6 col-6" style="margin-top: 30px">
      <div class="card">
        <div class="card-content rounded">
          <div class="card-body rounded-top" style="background-color: #112a5f"
            [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <div class="media text-center text-white font-weight-bold font-italic">
              <div class="col">
                <span class="text">Effactive Ammount Details </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <table class="table table-bordered" [ngClass]="{ 'dark-backround-table': selectedMode === 'dark' }">
          <tbody>
            @if (user_detail.salary_type !== 'hourly') {
              <tr>
                <th style="width: 50%; padding: 0px">
                  <p style="margin: 11px">Absent's</p>
                </th>
                <td>
                  {{
                  salary_detail.absents_amount === null
                  ? "0"
                  : salary_detail.absents_amount
                  }}/-
                </td>
              </tr>
            }
            @if (user_detail.salary_type !== 'hourly') {
              <tr>
                <th>Un Paid Leaves</th>
                <td>
                  {{
                  salary_detail.unpaid_leaves_amount === null
                  ? "0"
                  : salary_detail.unpaid_leaves_amount
                  }}/-
                </td>
              </tr>
            }

            @if (user_detail.salary_type !== 'hourly') {
              <tr>
                <th>Paid Leaves</th>
                <td>0/-</td>
              </tr>
            }

            @if (user_detail.salary_type !== 'hourly') {
              <tr>
                <th>Late Check In (Hours)</th>
                <td>
                  {{
                  salary_detail.late_check_in_amount === null
                  ? "0"
                  : salary_detail.late_check_in_amount
                  }}/-
                </td>
              </tr>
            }
            @if (user_detail.salary_type !== 'hourly') {
              <tr>
                <th>Short Hours</th>
                <td>
                  {{
                  salary_detail.short_hours_amount === null
                  ? "0"
                  : salary_detail.short_hours_amount
                  }}/-
                </td>
              </tr>
            }
            @if (user_detail.salary_type !== 'hourly') {
              <tr>
                <th>Over Time (Hours)</th>
                <td>
                  {{
                  salary_detail.overtime_amount === null
                  ? "0"
                  : salary_detail.overtime_amount
                  }}/-
                </td>
              </tr>
            }
            @if (user_detail.salary_type === 'hourly') {
              <tr>
                <th>Total Salary Amount</th>
                <td>
                  {{
                  salary_detail.total_worked_hours
                  * salary_detail.basic_salary
                  }}/-
                </td>
              </tr>
            }

          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xl-6 col-sm-6 col-6" style="margin-top: 30px">
      <div class="card">
        <div class="card-content rounded">
          <div class="card-body rounded-top" style="background-color: #112a5f"
            [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <div class="media text-center text-white font-weight-bold font-italic">
              <div class="col">
                <span class="text">Final Details</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <table class="table table-bordered" [ngClass]="{ 'dark-backround-table': selectedMode === 'dark' }">
          <tbody>
            <tr>
              <th style="width: 50%; padding: 0px">
                <p style="margin: 11px">
                  Total {{ user_detail.salary_type === 'hourly' ? 'Per Hour' : (user_detail.salary_type === 'monthly'
                  ?
                  'Per
                  Monthly' :
                'Monthly') }} Salary</p>
              </th>
              <td>{{ salary_detail.basic_salary }}/-</td>
            </tr>

            @if (user_detail.salary_type !== 'hourly') {
              <tr>
                <th>Total Deductions</th>
                <td>
                  {{
                  salary_detail.total_deduction === null
                  ? "0"
                  : salary_detail.total_deduction
                  }}/-
                </td>
              </tr>
            }
            <tr>
              <th>Tax on Salary</th>
              <td>
                <div class="col">
                  <input type="number" name="tax_amount" id="tax_amount" class="form-control" ngModel
                    #title="ngModel" />
                  </div>
                </td>
              </tr>
              <tr>
                <th>Final Received Salary</th>
                <td style="
                  font-weight: bold;
                  background-color: #7cf5d9;
                  text-align: center;
                  font-size: 20px;
                " [ngClass]="{ 'dark-backround-table': selectedMode === 'dark' }">
                  {{
                  salary_detail.released_salary === null
                  ? "0"
                  : salary_detail.released_salary
                  }}/-
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-xl-6 col-sm-6 col-6" style="margin-top: 30px">
        <div class="card">
          <div class="card-content rounded">
            <div class="card-body rounded-top" style="background-color: #112a5f"
              [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
              <div class="media text-center text-white font-weight-bold font-italic">
                <div class="col">
                  <span class="text">Other Adjustments </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <table class="table table-bordered" [ngClass]="{ 'dark-backround-table': selectedMode === 'dark' }">
            <tbody>
              <tr>
                <th style="width: 50%; padding: 0px">
                  <p style="margin: 11px">Advance Ammount</p>
                </th>
                <td>
                  <div class="col">
                    <input type="number" value="0" name="advance_payment" id="advance_payment" class="form-control"
                      ngModel #title="ngModel" />
                    </div>
                  </td>
                </tr>

                <tr>
                  <th>Compensations Amount</th>
                  <td>
                    <div class="col">
                      <input type="number" name="compensation_amount" id="compensation_amount" class="form-control"
                        ngModel #title="ngModel" />
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th>Other Deduction</th>
                    <td>
                      <div class="col">
                        <input type="number" name="other_duduction" id="other_duduction" class="form-control" ngModel
                          #title="ngModel" />
                        </div>
                      </td>
                    </tr>

                    @if (isActiveLoan()) {
                      <tr>
                        <th>Loan Amount </th>
                        <td>
                          <div class="col">
                            <input type="number" name="loan_amount" id="loan_amount" class="form-control" ngModel
                              #title="ngModel" />
                            </div>
                          </td>
                        </tr>
                      }

                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="row justify-content-center">
              <div class="col-xl-10" style="margin-top: 50px; margin-bottom: 50px">
                @if (isNotdraft()) {
                  <button (click)="setSalaryOnHold()" data-html2canvas-ignore="true" type="button "
                    class="btn btn-warning" style="margin-left: 10px; width: 250px; height: 50px">
                    On Hold
                  </button>
                }
                @if (isNotdraft()) {
                  <button (click)="setSalaryReleased()" data-html2canvas-ignore="true" type="button "
                    class="btn btn-primary" style="margin-left: 10px; width: 250px; height: 50px">
                    Released
                  </button>
                }
                @if (isNotdraft()) {
                  <button (click)="setSalaryBackToDraft()" data-html2canvas-ignore="true" type="button "
                    class="btn btn-danger" style="margin-left: 10px; width: 250px; height: 50px">
                    Draft
                  </button>
                }
                @if (isNotdraft()) {
                  <button (click)="setSalaryApproved()" data-html2canvas-ignore="true" type=" button "
                    class="btn btn-success" style="margin-left: 10px; width: 250px; height: 50px">
                    Approved
                  </button>
                }

                @if (isdraft()) {
                  <button (click)="genrateSalary()" data-html2canvas-ignore="true" type="button "
                    class="btn btn-primary" style="margin-left: 10px; width: 250px; height: 50px">
                    Genrate New Salary
                  </button>
                }
                @if (isdraft()) {
                  <button (click)="updateSalary()" data-html2canvas-ignore="true" type="button "
                    class="btn btn-warning" style="margin-left: 10px; width: 250px; height: 50px">
                    Update Salary
                  </button>
                }
                @if (isdraft()) {
                  <button (click)="saveGenratedSalary()" data-html2canvas-ignore="true" type="button "
                    class="btn btn-info" style="margin-left: 10px; width: 250px; height: 50px">
                    Save Genrated Salary
                  </button>
                }
              </div>
            </div>
          </div>
        </main>